export default __webpack_public_path__ + "static/065-c5895299cbae67939bdf1d78ce3f4f85.jpg";